import { useEffect, useRef, useState } from "react";

// Order intentional: 30.000+ first, 100s separated by 24h to avoid visual duplication.
const STATS = [
  { value: 30000, suffix: "+", label: "bearbeitete Fotos" },
  { value: 100, suffix: "+", label: "realisierte Projekte" },
  { display: "24h", label: "Lieferzeit ab" },
  { value: 100, suffix: "%", label: "Zufriedenheit" },
];

function Counter({ to, suffix }) {
  const [v, setV] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          const dur = 1400;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min((t - start) / dur, 1);
            setV(Math.round(to * (1 - Math.pow(1 - p, 3))));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          io.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, [to]);
  return <span ref={ref}>{v.toLocaleString("de-DE")}{suffix}</span>;
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-16 md:py-20 bg-[#F8F5EF] border-b border-[#EAE6DE]">
      <div className="container-x grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
        {STATS.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="reveal">
            <div className="ticker-num text-5xl md:text-7xl text-[#1A1A1A] leading-none whitespace-nowrap">
              {s.display ? s.display : <Counter to={s.value} suffix={s.suffix} />}
            </div>
            <div className="mt-4 flex items-center gap-3">
              <span className="overline text-[10px] text-[#5A5A5A]">{s.label}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
